import React from "react";
import { fetchRoles, selectAllRoles } from "./roleSlice";
import { Select } from "antd";
import { useDispatch, useSelector } from "react-redux";

const { Option } = Select;

const RoleSelector = ({ value, onChange }) => {
	const dispatch = useDispatch();
	React.useEffect(() => {
		dispatch(fetchRoles());
	}, [dispatch]);

	const roles = useSelector(selectAllRoles);

	return (
		<Select value={value} onChange={onChange}>
			{roles.map((t) => (
				<Option key={t.id} value={t.roleId}>
					{t.roleName}
				</Option>
			))}
		</Select>
	);
};

export default RoleSelector;
